function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { property as m } from "./property.js";
import { identity as p } from "../../function/identity.js";
import { mapValues as s } from "../../object/mapValues.js";
function a(o, r) {
  var _r;
  switch (r = (_r = r) !== null && _r !== void 0 ? _r : p, _typeof(r)) {
    case "string":
    case "symbol":
    case "number":
    case "object":
      return s(o, m(r));
    case "function":
      return s(o, r);
  }
}
export { a as mapValues };